/* Privé 2027 – filtro de precio con barra deslizable y filtros fijos */
(function () {
  function fmt(n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function montar(pr) {
    if (pr.querySelector('.pv-rango')) return;
    var ins = pr.querySelectorAll('input');
    if (ins.length < 2) return;
    var max = parseInt(pr.getAttribute('data-pv-max'), 10) || 0;
    if (max <= 0) return;
    var paso = max > 6000 ? 100 : 50;
    max = Math.ceil(max / paso) * paso;
    var val = [
      Math.min(parseInt(pr.getAttribute('data-pv-min-val'), 10) || 0, max),
      Math.min(parseInt(pr.getAttribute('data-pv-max-val'), 10) || max, max)
    ];

    var w = document.createElement('div');
    w.className = 'pv-rango';
    w.innerHTML =
      '<div class="pv-rango__pista"><span class="pv-rango__lleno"></span>' +
      '<button type="button" class="pv-rango__tirador" role="slider" aria-label="Precio mínimo"></button>' +
      '<button type="button" class="pv-rango__tirador" role="slider" aria-label="Precio máximo"></button></div>' +
      '<div class="pv-rango__valores"><span></span><span></span></div>';
    pr.insertBefore(w, pr.firstChild);

    var pista = w.querySelector('.pv-rango__pista');
    var lleno = w.querySelector('.pv-rango__lleno');
    var t = w.querySelectorAll('.pv-rango__tirador');
    var txt = w.querySelectorAll('.pv-rango__valores span');

    function pintar() {
      var a = (val[0] / max) * 100, b = (val[1] / max) * 100;
      t[0].style.left = a + '%';
      t[1].style.left = b + '%';
      t[0].style.zIndex = val[0] > max / 2 ? 3 : 1;
      lleno.style.left = a + '%';
      lleno.style.width = (b - a) + '%';
      txt[0].textContent = fmt(val[0]);
      txt[1].textContent = fmt(val[1]) + (val[1] >= max ? '+' : '');
      [0, 1].forEach(function (i) {
        t[i].setAttribute('aria-valuemin', i ? val[0] + paso : 0);
        t[i].setAttribute('aria-valuemax', i ? max : val[1] - paso);
        t[i].setAttribute('aria-valuenow', val[i]);
        t[i].setAttribute('aria-valuetext', fmt(val[i]));
      });
    }
    function fijar(i, v) {
      v = Math.round(v / paso) * paso;
      if (i === 0) v = Math.max(0, Math.min(v, val[1] - paso));
      else v = Math.min(max, Math.max(v, val[0] + paso));
      val[i] = v;
      pintar();
    }
    function enviar() {
      ins[0].value = val[0] > 0 ? val[0] : '';
      ins[1].value = val[1] < max ? val[1] : '';
      ins[1].dispatchEvent(new Event('input', { bubbles: true }));
    }
    function valorEn(clientX) {
      var r = pista.getBoundingClientRect();
      return Math.max(0, Math.min(1, (clientX - r.left) / r.width)) * max;
    }

    [0, 1].forEach(function (i) {
      var h = t[i];
      h.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        h.setPointerCapture(e.pointerId);
        h.classList.add('is-activo');
        function mover(ev) { fijar(i, valorEn(ev.clientX)); }
        function soltar() {
          h.removeEventListener('pointermove', mover);
          h.removeEventListener('pointerup', soltar);
          h.removeEventListener('pointercancel', soltar);
          h.classList.remove('is-activo');
          enviar();
        }
        h.addEventListener('pointermove', mover);
        h.addEventListener('pointerup', soltar);
        h.addEventListener('pointercancel', soltar);
      });
      h.addEventListener('keydown', function (e) {
        var d = { ArrowLeft: -paso, ArrowDown: -paso, ArrowRight: paso, ArrowUp: paso }[e.key];
        if (d === undefined) return;
        e.preventDefault();
        fijar(i, val[i] + d);
      });
      h.addEventListener('keyup', function (e) {
        if (/Arrow/.test(e.key)) enviar();
      });
    });
    // tocar la pista mueve el tirador más cercano
    pista.addEventListener('pointerdown', function (e) {
      if (e.target.classList.contains('pv-rango__tirador')) return;
      var v = valorEn(e.clientX);
      var i = Math.abs(v - val[0]) <= Math.abs(v - val[1]) ? 0 : 1;
      fijar(i, v);
      enviar();
    });
    pintar();
  }

  function todo() { document.querySelectorAll('price-range[data-pv-max]').forEach(montar); }
  todo();
  var tm;
  new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(todo, 80); })
    .observe(document.body, { childList: true, subtree: true });

  // Filtros de escritorio siempre abiertos: no se pueden cerrar
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.facets__disclosure-vertical > summary');
    if (s) e.preventDefault();
  }, true);
})();
